import {useEffect} from 'react'

type WebVitalName = 'inp' | 'lcp' | 'cls' | 'hpc'

export function useWebVitals(
  name: WebVitalName,
  callback: (event: CustomEvent<PlatformBrowserPerformanceWebVitalTiming>) => void,
) {
  useEffect(() => {
    const eventName = `web-vitals:${name}`
    const eventListener = callback as EventListener

    document.addEventListener(eventName, eventListener)

    return () => {
      document.removeEventListener(eventName, eventListener)
    }
  })
}
